import { Property } from '@bbraun/bav-reporting/ui-report-editor';
import { marker as i18n } from '@ngneat/transloco-keys-manager/marker';
import { IS_GREATER_OR_EQUAL_NUMBER_ID } from '../../../../validation/factories/is-greater-or-equal-number-validator-factory';
import { IS_GREATER_THAN_ZERO_WHEN_ONE_PROPERTY_IS_GREATER_ZERO_ID } from '../../../../validation/factories/is-greater-than-zero-when-one-of-property-is-number-validator-factory';
import { IS_NUMBER_INTEGER_ID } from '../../../../validation/factories/is-number-integer-validator-factory';

export function createHospOtherHospProperty(): Property {
  return {
    title: null,
    technicalName: 'hospOtherHosp',
    dataType: 'number',
    unit: null,
    highlighted: false,
    subName: null,
    formula: null,
    validation: [
      { validator: IS_NUMBER_INTEGER_ID },
      {
        validator: IS_GREATER_OR_EQUAL_NUMBER_ID,
        options: {
          config: {
            minimum: 0,
          },
        },
      },
      {
        validator: IS_GREATER_THAN_ZERO_WHEN_ONE_PROPERTY_IS_GREATER_ZERO_ID,
        options: {
          config: {
            properties: ['hospOtherHosp', 'hospOtherPatient', 'hospOtherDays'],
          },
          messageKey: i18n(
            'bbraunBavReportingFeatureAisReports.validation.hospOtherHosp.notGreaterZero.oneOtherIsSet.error.message',
          ),
        },
      },
    ],
  };
}
